export default __webpack_public_path__ + "static/media/stackholder1.987a51fa.png";